import { RefMessage } from '../../framework/infra'

export default class PersonMessage extends RefMessage {
    static messages = []
}
